import React from 'react';
import { Loader2 } from 'lucide-react';

const variants = {
  primary:
    'bg-camp-green text-white hover:bg-camp-600 focus:ring-camp-green/30',
  secondary:
    'bg-camp-100 text-camp-800 hover:bg-camp-200 focus:ring-camp-green/20',
  outline:
    'border border-camp-300 bg-white text-camp-700 hover:bg-camp-50 focus:ring-camp-green/20',
  ghost:
    'bg-transparent text-camp-700 hover:bg-camp-50 focus:ring-camp-green/20',
  danger:
    'bg-camp-danger text-white hover:bg-red-700 focus:ring-red-500/30',
};

const sizes = {
  sm: 'min-h-9 px-3 text-sm',
  md: 'min-h-10 px-4 text-sm',
  lg: 'min-h-12 px-5 text-base',
};

export default function CampButton({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  className = '',
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={[
        'inline-flex items-center justify-center gap-2',
        'rounded-camp font-semibold',
        'transition-colors duration-150',
        'focus:outline-none focus:ring-4',
        'disabled:cursor-not-allowed disabled:opacity-50',
        variants[variant] || variants.primary,
        sizes[size] || sizes.md,
        className,
      ].join(' ')}
      {...props}
    >
      {loading && <Loader2 size={17} className="animate-spin" />}
      {children}
    </button>
  );
}
